define(["jquery"], function($) {
	return function(dom, opts) {
		var options = $.extend({
			cls: "overlay-open",
			eventOpen: "OVERLAY_OPEN",
			eventClose: "OVERLAY_CLOSE"
		}, opts);

		var isOpen = false;

		$(document).on(options.eventOpen, function() {
			isOpen = true;
			$(dom).addClass(options.cls);
		});
		$(document).on(options.eventClose, function() {
			isOpen = false;
			$(dom).removeClass(options.cls);
		});
	}
});
